export default "__VITE_ASSET__I3gjMNxS__"